// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__ACZ7I","svg":"Pagination_svg__lYvZe","list":"Pagination_list__bos0j","item":"Pagination_item__NzhhP","active":"Pagination_active__aFfce"};